// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-row {
  display: flex;
  margin: 0;
  align-items: center;
}
.form-row.form-row-title {
  display: flex;
  justify-content: center;
}
.form-row.form-row-title .row-name-container {
  font-size: 110%;
  font-weight: 600;
  margin: 40px 0 20px;
}

.label-container,
.field-container {
  padding: 10px;
}

.label-container {
  flex: 1;
  max-width: 200px;
  text-align: right;
  font-size: 14px;
  padding-top: 15px;
}
@media screen and (max-width: 650px) {
  .label-container {
    flex-basis: 100%;
    max-width: 100%;
    text-align: left;
  }
}
.label-container.section-title {
  font-weight: 600;
  margin-top: 20px;
}

.field-container {
  flex: 3;
  max-width: 500px;
  font-size: 14px;
}
.field-container.radio-container div label {
  display: flex;
  align-items: center;
  gap: 5px;
}
.field-container.radio-container div label input {
  height: 29px;
  top: -2px;
  position: relative;
}
.field-container.week-days-time-selection {
  max-width: 600px;
}
.field-container.image-upload-container {
  display: flex;
}
@media screen and (max-width: 850px) {
  .field-container.image-upload-container {
    flex-direction: column;
  }
}
.field-container.image-upload-container.df-column {
  flex-direction: column;
}
.field-container.image-upload-container.img-preview {
  gap: 13px;
}
.field-container.image-upload-container .img-preview-cont {
  padding: 10px 10px 10px 0;
}
@media screen and (max-width: 850px) {
  .field-container.image-upload-container .img-preview-cont {
    display: flex;
    flex-direction: column;
  }
}
.field-container.image-upload-container .img-preview-cont img {
  max-width: 100px;
}
.field-container.image-upload-container .img-preview-cont .rem-img-btn {
  min-width: 121px;
  max-width: 150px;
  height: 28px;
  font-size: 13px;
  margin-top: 10px;
}
.field-container.image-upload-container app-file-input .drop-area.file-drop-area {
  margin-top: 0;
}
@media screen and (max-width: 650px) {
  .field-container.image-upload-container app-file-input .drop-area.file-drop-area {
    width: 100%;
  }
}
.field-container .error-message {
  color: red;
  font-weight: bold;
  font-size: 13px;
  margin-top: 5px;
}
.field-container .checkbox-container {
  width: 150px;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
}
.field-container .checkbox-container input {
  width: 16px;
  height: 16px;
}
.field-container .checkbox-container label {
  height: 14px;
}
.field-container .checkbox-container input:hover,
.field-container .checkbox-container label:hover {
  cursor: pointer;
}
.field-container .textarea {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  width: 100%;
  padding-left: 10px;
}
.field-container select {
  width: 100%;
}
.field-container.horizontal-centered {
  display: flex;
  align-items: flex-end;
}
.field-container.hover-pointer *:hover {
  cursor: pointer;
}
.field-container .file-input-error {
  font-weight: 700;
  font-size: 14px;
  margin-top: 10px;
  color: red;
}
.field-container .allowed-file-types {
  font-size: 12px;
  font-style: italic;
  margin-top: 10px;
}

select,
input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 38px;
  padding-left: 10px;
  font-size: 14px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
